var _use, _use2, _use3, _use4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGerade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 760 288",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Pfosten",
    xlinkHref: "#_Image1",
    x: 563.957,
    y: 0,
    width: "32.954px",
    height: "287.7px",
    transform: "matrix(0.998595,0,0,0.998958,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pfosten",
    transform: "matrix(-1.16453,0,0,0.98957,1276.32,-23.5595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.961,
    y: 12.696,
    width: 18.851,
    height: 301.844,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Gestell",
    xlinkHref: "#_Image2",
    x: 0,
    y: 0,
    width: "760px",
    height: "258.923px",
    transform: "matrix(1,0,0,0.999703,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gestell",
    transform: "matrix(1,0,0,1,5.68434e-14,0.262846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.422,252.242L0,252.242L0,0L8.422,0L8.422,26.182L582.551,26.182L582.551,-1.235L590.973,-1.235L590.973,25.731L760,243.482L760,251.981L8.422,252.239L8.422,252.242ZM591.364,42.425L590.973,243.875L743.615,243.52L591.364,42.425ZM582.551,34.288L8.422,34.288L8.422,243.872L582.551,243.656L582.551,34.288Z",
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "1101C"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08126,96.002,-53.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.958,
    y: 49.803,
    width: 4.367,
    height: 231,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.0947,196.002,-56.1233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.958,
    y: 51.268,
    width: 4.367,
    height: 226.733,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.0947,296.002,-56.1233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.958,
    y: 51.268,
    width: 4.367,
    height: 226.733,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08375,396.002,-56.3571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.958,
    y: 52.002,
    width: 4.367,
    height: 228.301,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08361,621.003,-53.9668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08743,646.003,-54.1571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08743,671.003,-54.1571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08361,746.004,-53.9668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08361,796.004,-53.9668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.959,
    y: 49.803,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,246.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.07459,846.004,-53.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435.959,
    y: 49.803,
    width: 4.367,
    height: 232.433,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08368,896.004,-55.5582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.959,
    y: 51.268,
    width: 4.367,
    height: 229.039,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.07459,946.004,-53.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.959,
    y: 49.803,
    width: 4.367,
    height: 232.433,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,148.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.878683,0,0,1.10458,322.912,-56.6298)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.958,
    y: 51.268,
    width: 4.367,
    height: 224.705,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,446.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,496.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.10437,521.002,-55.0007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.958,
    y: 49.803,
    width: 4.367,
    height: 226.167,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08299,1002,-54.0801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08299,1052,-54.0801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08299,1102,-54.0801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1.08299,1127.2,-54.0801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.959,
    y: 49.936,
    width: 4.367,
    height: 230.5,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "querbalken unten",
    xlinkHref: "#_Image3",
    x: 8.279,
    y: 215.54,
    width: "574.432px",
    height: "8.729px",
    transform: "matrix(0.999011,0,0,0.969934,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "querbalken unten",
    transform: "matrix(6.12323e-17,1,-1.99558,1.22194e-16,582.551,209.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8.427,
    height: 287.7,
    style: {
      fill: "rgb(74,76,79)"
    }
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "unteres Gestell",
    xlinkHref: "#_Image4",
    x: 0,
    y: 260.247,
    width: "760px",
    height: "18.067px",
    transform: "matrix(1,0,0,0.950886,0,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "unteres Gestell",
    transform: "matrix(0.988752,0,0,1.06875,-35.5535,212.288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.958,
    y: 36.904,
    width: 768.624,
    height: 10.587,
    style: {
      fill: "rgb(74,76,79)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "33px",
    height: "288px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAEgCAYAAAA6zxp+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABsElEQVR4nO3STUsjQRgA4UpUFr148KD//98teBK/EqPZw74VokhQkmMVNDNMZrqf6cwCWAIXwBVwDdwAt8DdnF8CC47rGbgH/s64Bx7m+tvyyMlPUggLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEhbAQFsJCWAgLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEhbAQFsJCWAgLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEhbAQFsJCWAgLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEhbAQFsJCWAgLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEhbAQFsJCWAgLYSEshIWwEBbCQlgIC2EhLISFsBAWwkJYCAthISyEHUJsT7jO9tB8y29u3AIfe+OUiH3MDvV1JwS8Axvgbc6PyXk2M3y5Hej8wOIr4GXu+TPHxS8W3858LzNe9zAi+A6xAdbzwNP8/vEF8RPI/kutgEfgeTDrub7bjXM+fwebeeiJ/3/V+4AugLNfIpxzPYsLWc2O7HbjH2CvWzqPq9zdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "760px",
    height: "259px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "575px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAj8AAAAJCAYAAADdEE2uAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAdklEQVR4nO3asQ3CMBBA0Q/xCjSMxP5bZAZHFIERokjJe5IbV1d+2feoPtWregYAcF1btY728HlXy7nzAAAcalaN9uj5HwCAK1t8dQEAtyJ+AIBbET8AwK2IHwDgVkb75vM8exAAgIPNao5q/V14BQIArmyr1i8zYQppg3gGZAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "760px",
    height: "19px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAvgAAAATCAYAAADlPnmLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABSklEQVR4nO3dzWrUABSA0S/TtGoRBDf2/d/OhaB2dNrOT1zEOG4Ed5pwDiRZhECWH5dLMlRjtQsAAFiraTnG6r66qYafN4c/PQUAAPw3pt+ul+pcHcfqfXXbHPkl8AEAYA2WwL9Ux+q5OozVh+pNc+SLewAAWI+pOlVP1WP1eaweqrfVq+ziAwDAmizT+2/NA/vzsqJzn7gHAIA1mpqH9cdqv2tezxH3AACwTkNz07+u7oQ9AABsw021E/gAALANu18nAABgEwaBDwAAGyLwAQBgGy7VJPABAGAbztVlVx26/uYWAABYn0Pz32xfxupT9VLdNX9Dc/iHLwYAAPy9S3Wq9tWX6jBWH6uv1ZidfAAAWJOpOfCfqsdqvwT+bXPcm+ADAMA6LGv2l+pYPVffh+pd17gHAADWZeq6qnMamqf34h4AANZrifx+AMnPO87xJZEhAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerade);
export default __webpack_public_path__ + "static/media/gerade.76852f166dec1307236403ffff4170b1.svg";
export { ForwardRef as ReactComponent };